import React from "react";
import CallToAction from "../base/CallToAction";
import {useNavigate} from "react-router"

const Pending = () => {

 const route = useNavigate()

  return (
    <CallToAction title="Necesitamos verificar tu identidad 🙂" subtitle={<div>Para poder utilizar tu app al completo. Necesitamos que valides tu identidad. De esta manera mantenemos una plataforma segura para todos.</div>} 
    button={{visible:true, title:'Validar mi identidad', action:()=>{route('/MenuKycScreen')}}}/>     
  );
};

export default Pending;
